import { useLayoutEffect } from "react";

function LabelCanvas({ canvasId, width = 240, height = 96, qrCode, text }: { canvasId: string, width?: number, height?: number, qrCode: string, text: string }) {
  useLayoutEffect(() => {
    const canvas = document.getElementById(canvasId) as HTMLCanvasElement;
    if (!canvas) {
      return;
    }

    canvas.width = width;
    canvas.height = height;

    const qrCodeImage = new Image();
    qrCodeImage.src = qrCode;
    new Promise<HTMLImageElement>((resolve, reject) => {
      qrCodeImage.onload = () => resolve(qrCodeImage);
      qrCodeImage.onerror = reject;
    })
      .then(() => {
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          return;
        }
        ctx.fillStyle = "white";
        ctx.lineWidth = 3;
        // fill background
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        // Draw QR code
        ctx.fillStyle = "black";
        ctx.drawImage(qrCodeImage, 0, 0, 96, 96);
        // Draw text
        ctx.font = "32px serif";
        ctx.fillText(text, 100, 56);
        // ctx.fillText(`${drone._id}`, 100, 68);
      });
  }, []);

  return <canvas id={canvasId}></canvas>;
}

export default LabelCanvas;
